import { IFsLprResult } from './result';

export interface IFsHistoricalProviderResultsInterface {
  results: IFsLprResult[];
  total: number;
}
